import {useIsNavigatingOrPending} from '../../../support/use_is_navigating_or_pending';
import formStyles from '../../../components/form/form.module.scss';
import {Button} from '../../../components/button/button';
import {classNames} from '../../../support/classnames';
import {__, transString} from '../../../support/lang/translations';
import {useAppSelector} from '../../../store/store';
import {CustomerFieldKeys, getValue} from '../../../support/get_data';
import {ButtonColorType} from '../../../enums/button_color_type.ts';
import buttonStyles from '../../../components/button/button.module.scss';

export function ContactDetailsTitle() {
    return (
        <>
            <h1>{__('onboarding.contact.title')}</h1>
            <h2>{__('onboarding.contact.subtitle')}</h2>
        </>
    );
}

interface ContentProps {
    isEditing: boolean;
    onEditClick: () => void;
    setCanSubmit: (value: boolean) => void;
}
export function ContactDetailsContent(props: ContentProps) {
    const isLoading = useIsNavigatingOrPending((state) => state.customerInfo.status);

    const meData = useAppSelector((state) => state.customerInfo.me?.customer);
    const emailData = getValue(meData, CustomerFieldKeys.EMAIL);
    const phoneNumberData = getValue(meData, CustomerFieldKeys.PHONE_NUMBER);

    function checkEmail(email: string) {
        let canSubmit = true;
        if (email.length === 0) {
            canSubmit = false;
        }

        const emailRegexCheck = new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$');

        if (!emailRegexCheck.test(email)) {
            canSubmit = false;
        }

        props.setCanSubmit(canSubmit);
    }

    return (
        <>
            <h2>{__('onboarding.contact.content_title')}</h2>

            <div className={formStyles.form} onClick={() => props.onEditClick()}>
                <div className={formStyles.form__grid}>
                    <div className={formStyles.grid__full}>
                        <label>
                            {emailData?.name ?? __('onboarding.contact.fields.email')}
                            <input
                                className={classNames({[formStyles.locked]: !props.isEditing})}
                                defaultValue={emailData?.value ?? ''}
                                placeholder={transString('onboarding.contact.fields.email')}
                                name={emailData?.key ?? CustomerFieldKeys.EMAIL}
                                type="email"
                                required={true}
                                disabled={isLoading}
                                onChange={(e) => checkEmail(e.target.value)}
                            />
                        </label>
                    </div>
                    <div className={formStyles.grid__full}>
                        <label>
                            {phoneNumberData?.name ?? __('onboarding.contact.fields.phone')}
                            <input
                                className={classNames({[formStyles.locked]: !props.isEditing})}
                                defaultValue={phoneNumberData?.value ?? ''}
                                placeholder={transString('onboarding.contact.fields.phone')}
                                name={phoneNumberData?.key ?? CustomerFieldKeys.PHONE_NUMBER}
                                type="tel"
                                disabled={isLoading}
                            />
                        </label>
                    </div>
                </div>
            </div>
        </>
    );
}

interface FooterProps {
    isEditing: boolean;
    setIsEditing: (isEditing: boolean) => void;
    onPrevSlide: () => void;
    onNextSlide: () => void;
    canSubmit: boolean;
}

export function ContactDetailsFooter(props: FooterProps) {
    return (
        <>
            <div>
                {props.isEditing ? (
                    <span />
                ) : (
                    <div>
                        <Button
                            className={buttonStyles.button_step}
                            type="button"
                            onClick={() => props.setIsEditing(true)}
                            colorType={ButtonColorType.Black}
                        >
                            <i className="fa-light fa-x" />
                            <span>{__('onboarding.contact.buttons.invalid')}</span>
                        </Button>
                    </div>
                )}
            </div>
            <div>
                <Button
                    className={buttonStyles.button_step}
                    type="button"
                    onClick={() => props.onNextSlide()}
                    colorType={ButtonColorType.Green}
                    disabled={!props.canSubmit}
                >
                    <i className="fa-light fa-check" />
                    {props.isEditing ? (
                        <span>{__('onboarding.contact.buttons.next')}</span>
                    ) : (
                        <span>{__('onboarding.contact.buttons.valid')}</span>
                    )}
                </Button>
            </div>
        </>
    );
}
